export default {
  data() {
    return {
      nombreRecurso: 'RECURSO',
      items: [],
      cargando: false,
      itemSeleccionado: null,
      itemsSeleccionados: [],
      busqueda: '',
    };
  },
  methods: {
    seleccionarItem(itemSeleccionado) {
      this.itemSeleccionado = itemSeleccionado;
    },
    seleccionarItems(itemsSeleccionados) {
      this.itemsSeleccionados = itemsSeleccionados;
    },
    buscar(val) {
      this.$refs.listadoRef.updateSearchQuery(val);
    },
  },
};
